import {useState} from "../../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../../__snowpack__/pkg/hox.js";
export const useVariantOptionTags = () => {
  const defaultData = [{attributeId: "-", name: "-", id: "-"}];
  const [data, setDataRaw] = useState(defaultData);
  const [normalData, setNormalData] = useState([]);
  const [isVerChanges, setIsVerChanges] = useState(false);
  const setData = (val) => {
    return setDataRaw(val?.length ? val : defaultData);
  };
  const resetData = () => {
    return [{attributeId: "-", name: "-", id: "-", idBase64List: []}];
  };
  return {
    defaultData,
    variantOptionTags: data,
    setVariantOptionTags: setData,
    resetVariantOptionTags: resetData,
    setIsVerChanges,
    normalData,
    setNormalData,
    isVerChanges
  };
};
export const useVariantOptionTagsModel = createModel(useVariantOptionTags);
export const useShopCountry = () => {
  const [shopCountry, setShopCountry] = useState();
  const [shopIds, setShopIds] = useState([]);
  const [shops, setShops] = useState([]);
  return {
    shopCountry,
    setShopCountry,
    shopIds,
    setShopIds,
    shops,
    setShops
  };
};
export const useShopCountryModel = createModel(useShopCountry);
export const useCatrgoryInfo = () => {
  const [catrgoryInfo, setCatrgoryInfo] = useState();
  return {
    catrgoryInfo,
    setCatrgoryInfo
  };
};
export const useCatrgoryInfoModel = createModel(useCatrgoryInfo);
